import { render, staticRenderFns } from "./CorreoNuevo.vue?vue&type=template&id=46c81106&"
import script from "./CorreoNuevo.vue?vue&type=script&lang=js&"
export * from "./CorreoNuevo.vue?vue&type=script&lang=js&"
import style0 from "./CorreoNuevo.vue?vue&type=style&index=0&id=46c81106&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports